import React from 'react';
import dayliIcon from '../../assets/images/dayli-icon.svg';

import './SignupFooter.css';

const SignupFooter: React.FC = () => {
  return (
    <footer className="signup-footer">
      <div className="signup-footer-content">
        {/* Left section with logo and copyright */}
        <div className="signup-footer-left">
          <div className="signup-footer-logo">
          <img src={dayliIcon} alt="Dayli Icon" className="signup-footer-icon" />
          <span className="signup-footer-brand">dayli</span>
          </div>
          <div className="signup-footer-info">
            <p className="signup-copyright">© Ryze India Advisory Limited. All rights reserved.</p>
            <p className="signup-contact">
              Need help? Reach us at<br />
              <a href="mailto:support@dayli.cards" className="signup-contact-link">support@dayli.cards</a>
            </p>
          </div>
        </div>    
      </div>
    </footer>
  );
};

export default SignupFooter; 